export default __webpack_public_path__ + "static/media/image-gallery-1.51bc54ac.jpg";